
<h2 class="text-primary">{{resultJson.benchmark}} v{{resultJson.benchmark_version}}</h2>

<mat-grid-list cols="5" gutterSize="20px" rowHeight="180px" style="margin-bottom: 20px;">
  <mat-grid-tile>
    <div class="dashboard-tile">
      <div class="tile-header">
        <div class="tile-header-title">Scan Summary</div>
      </div>
      <div class="tile-content">
        <div>Profile: {{resultJson.profile}}</div>
        <div>Start: {{resultJson.start_time | date:'medium'}}</div>
        <div>End: {{resultJson.end_time | date:'medium'}}</div>
      </div>
    </div>
  </mat-grid-tile>
  <mat-grid-tile>
    <div class="dashboard-tile">
      <div class="tile-header">
        <div class="tile-header-title">Default</div>
      </div>
      <div class="tile-content" style="text-align: center;">
        <div>Score: <span class="text-primary">{{resultJson.sys_default_score | number:'1.0-0'}} / {{resultJson.sys_default_maximum}}</span></div>
        <ngx-gauge type="full"
          [value]="resultJson.sys_default_percentage * 100"
          duration="750"
          size="80"
          thick="7"
          append="%"
          [foregroundColor]="themeService.themeColors.primary"
          [backgroundColor]="themeService.themeColors.accent">
        </ngx-gauge>
      </div>
    </div>
  </mat-grid-tile>
  <mat-grid-tile>
    <div class="dashboard-tile">
      <div class="tile-header">
        <div class="tile-header-title">Absolute</div>
      </div>
      <div class="tile-content" style="text-align: center;">
        <div>Score: <span class="text-primary">{{resultJson.sys_absolute_score | number:'1.0-0'}} / {{resultJson.sys_absolute_maximum}}</span></div>
        <ngx-gauge type="full"
          [value]="resultJson.sys_absolute_percentage * 100"
          duration="750"
          size="80"
          thick="7"
          append="%"
          [foregroundColor]="themeService.themeColors.primary"
          [backgroundColor]="themeService.themeColors.accent">
        </ngx-gauge>
      </div>
    </div>
  </mat-grid-tile>
  <mat-grid-tile>
    <div class="dashboard-tile">
      <div class="tile-header">
        <div class="tile-header-title">Flat</div>
      </div>
      <div class="tile-content" style="text-align: center;">
        <div>Score: <span class="text-primary">{{resultJson.sys_flat_score | number:'1.0-0'}} / {{resultJson.sys_flat_maximum}}</span></div>
        <ngx-gauge type="full"
          [value]="resultJson.sys_flat_percentage * 100"
          duration="750"
          size="80"
          thick="7"
          append="%"
          [foregroundColor]="themeService.themeColors.primary"
          [backgroundColor]="themeService.themeColors.accent">
        </ngx-gauge>
      </div>
    </div>
  </mat-grid-tile>
  <mat-grid-tile>
    <div class="dashboard-tile">
      <div class="tile-header">
        <div class="tile-header-title">Flat Unweighted</div>
      </div>
      <div class="tile-content" style="text-align: center;">
        <div>Score: <span class="text-primary">{{resultJson.sys_flat_unweighted_score | number:'1.0-0'}} / {{resultJson.sys_flat_unweighted_maximum}}</span></div>
        <ngx-gauge type="full"
          [value]="resultJson.sys_flat_unweighted_percentage * 100"
          duration="750"
          size="80"
          thick="7"
          append="%"
          [foregroundColor]="themeService.themeColors.primary"
          [backgroundColor]="themeService.themeColors.accent">
        </ngx-gauge>
      </div>
    </div>
  </mat-grid-tile>
</mat-grid-list>

<cw-ci-data-table #resultRulesDataTable
  tileTitle="Rules"
  defaultSortField="rule_id"
  defaultSortDirection="desc"
  skipInitialLoad="true"
  paginateResults="false"
  [isSelectable]="isSelectable"
  (loadItemsHandler)="loadScanResults($event)"
  (selectHandler)="selectRule($event)"
  [items]="ruleResults">

  <cw-ci-table-column columnName="rule_id" columnTitle="Rule" [output]="ruleTemplate" sortField="rule_id"></cw-ci-table-column>
  <ng-template let-element #ruleTemplate>{{element.rule_title}}<br><span class="text-accent">{{element.rule_id}}</span></ng-template>
  <cw-ci-table-column columnName="rule_references" columnTitle="References" [output]="referencesTemplate" minWidth="150px"></cw-ci-table-column>
  <ng-template let-element #referencesTemplate>
    <div style="display: flex; flex-direction: column">
      <a mat-stroked-button class="small" style="margin-top:4px;" color="primary" *ngFor="let identifier of element.rule_identifiers" (click)="openReference($event, identifier.identifier);">{{identifier.identifier}}</a>
    </div>
  </ng-template>
  <cw-ci-table-column columnName="rule_result" columnTitle="Result" sortField="rule_result" [output]="resultTemplate" minWidth="150px"></cw-ci-table-column>
  <ng-template let-element #resultTemplate>
    <div [style.color]="(element.rule_result == 'pass') ? 'green' : (element.rule_result == 'fail') ? 'red' : 'blue'">
      <mat-icon svgIcon="cw:flag_risk" style="vertical-align:middle"></mat-icon><span style="vertical-align:middle">{{element.rule_result}}</span>
    </div>
  </ng-template>
</cw-ci-data-table>